import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { clientOriginInterceptor } from './core/interceptors/client-origin.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideRouter } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { environment } from '@env/environment';
import { initRecaptcha } from './core/initializers/recaptcha.initializer';
import { initUserProfile } from './core/initializers/user-profile.initializer';
import { initAppPricing } from './core/initializers/app-pricing.initializer';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFunctions(() => getFunctions()),
    provideHttpClient(withInterceptors([clientOriginInterceptor, authInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAppInitializer(() => initRecaptcha()),
    provideAppInitializer(() => initUserProfile()),
    provideAppInitializer(() => initAppPricing()),
  ],
};
